// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const OnboardingStressSleepIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<circle cx={22} cy={22} r={22} fill="url(#OnboardingStressSleepIcon_tsx__a)" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.797 26.844c2.006 3.887 6.076 6.417 10.511 6.417 6.517 0 11.818-5.3 11.818-11.817 0-4.607-2.669-8.747-6.762-10.682a13.07 13.07 0 0 1 .418 3.29c0 7.23-5.882 13.11-13.112 13.11-.97 0-1.93-.106-2.873-.318Zm10.511 7.711c-5.42 0-10.35-3.407-12.266-8.478a.647.647 0 0 1 .814-.841c1.232.42 2.515.633 3.814.633 6.517 0 11.818-5.302 11.818-11.818 0-1.434-.256-2.838-.761-4.175a.647.647 0 0 1 .813-.841 13.109 13.109 0 0 1 8.88 12.409c0 7.23-5.882 13.111-13.112 13.111Z"
			fill="#fff"
		/>
		<defs>
			<linearGradient
				id="OnboardingStressSleepIcon_tsx__a"
				x1={0}
				y1={0}
				x2={44}
				y2={44}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#75B2F0" />
				<stop offset={1} stopColor="#B275F0" />
			</linearGradient>
		</defs>
	</svg>
);
export default OnboardingStressSleepIcon;
